import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';

const TestimonialsSection = () => {
  const [ref, isInView] = useInView({ threshold: 0.2 });

  const testimonials = [
    {
      name: 'Mohammed Al-Rashid',
      position: 'Project Manager, Saudi Binladin Group',
      content: 'Exceptional service and reliable equipment. Their heavy cranes were crucial for our high-rise project completion.',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/8946505317cdc00f8c5f416475bf0ff5.jpg',
    },
    {
      name: 'Ahmed Al-Otaibi',
      position: 'Construction Director, Al-Khorayef Group',
      content: 'Outstanding professionalism and safety standards. We trust Rawafi Al Mutahidun for all our major projects.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20Saudi%20Arabian%20construction%20manager%20in%20safety%20vest%20and%20hard%20hat%2C%20confident%20executive%20portrait%20at%20construction%20site%2C%20professional%20corporate%20photography%2C%20natural%20outdoor%20lighting%2C%20clean%20background&width=200&height=200&seq=testimonial-002&orientation=squarish',
    },
    {
      name: 'Khalid Al-Subaie',
      position: 'Operations Manager, Saudi Oger',
      content: 'Their equipment quality and technical support are unmatched. Highly recommended for any construction project.',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20Saudi%20Arabian%20operations%20manager%20in%20business%20casual%20attire%2C%20confident%20corporate%20portrait%20photography%2C%20modern%20industrial%20background%2C%20professional%20headshot%20style%2C%20natural%20lighting&width=200&height=200&seq=testimonial-003&orientation=squarish',
    },
  ];

  return (
    <section className="py-24 bg-neutral-50">
      <div className="container mx-auto px-4 lg:px-8" ref={ref}>
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 bg-accent rounded-full"></div>
            <span className="text-accent font-inter font-semibold text-sm uppercase tracking-wider">Testimonials</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-poppins font-black text-primary mb-6">
            Client Success Stories
          </h2>
          <p className="text-neutral-500 font-inter text-lg max-w-2xl mx-auto">
            Trusted by leading construction companies across Saudi Arabia
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-8 border-2 border-neutral-200 hover:border-accent transition-all duration-300"
            >
              {/* Rating */}
              <div className="flex items-center gap-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <div key={i} className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-lg text-accent"></i>
                  </div>
                ))}
              </div>

              {/* Content */}
              <p className="text-neutral-600 font-inter text-base leading-relaxed mb-8">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h4 className="font-poppins font-bold text-primary text-base">{testimonial.name}</h4>
                  <p className="text-neutral-500 font-inter text-sm">{testimonial.position}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
